/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VisualReference } from './VisualReference';
import {
    VisualReferenceFromJSON,
    VisualReferenceFromJSONTyped,
    VisualReferenceToJSON,
    VisualReferenceToJSONTyped,
} from './VisualReference';
import type { DailyDecisionMakingSkillsOption } from './DailyDecisionMakingSkillsOption';
import {
    DailyDecisionMakingSkillsOptionFromJSON,
    DailyDecisionMakingSkillsOptionFromJSONTyped,
    DailyDecisionMakingSkillsOptionToJSON,
    DailyDecisionMakingSkillsOptionToJSONTyped,
} from './DailyDecisionMakingSkillsOption';
import type { MakesSelfUnderstoodOption } from './MakesSelfUnderstoodOption';
import {
    MakesSelfUnderstoodOptionFromJSON,
    MakesSelfUnderstoodOptionFromJSONTyped,
    MakesSelfUnderstoodOptionToJSON,
    MakesSelfUnderstoodOptionToJSONTyped,
} from './MakesSelfUnderstoodOption';

/**
 * 
 * @export
 * @interface CognitiveLevelAssessmentForm
 */
export interface CognitiveLevelAssessmentForm {
    /**
     * 
     */
    severe_impairment?: boolean;
    /**
     * 
     */
    readonly predicted_severe_impairment?: boolean;
    /**
     * 
     */
    readonly predicted_severe_impairment_reasoning?: string | null;
    /**
     * 
     */
    readonly predicted_severe_impairment_visual_references?: Array<VisualReference>;
    /**
     * 
     */
    skills_for_daily_decision_making?: DailyDecisionMakingSkillsOption;
    /**
     * 
     */
    readonly predicted_skills_for_daily_decision_making?: DailyDecisionMakingSkillsOption;
    /**
     * 
     */
    readonly predicted_skills_for_daily_decision_making_reasoning?: string | null;
    /**
     * 
     */
    readonly predicted_skills_for_daily_decision_making_visual_references?: Array<VisualReference>;
    /**
     * 
     */
    makes_self_understood?: MakesSelfUnderstoodOption;
    /**
     * 
     */
    readonly predicted_makes_self_understood?: MakesSelfUnderstoodOption;
    /**
     * 
     */
    readonly predicted_makes_self_understood_reasoning?: string | null;
    /**
     * 
     */
    readonly predicted_makes_self_understood_visual_references?: Array<VisualReference>;
    /**
     * 
     */
    has_memory_problems?: boolean;
    /**
     * 
     */
    readonly predicted_has_memory_problems?: boolean;
    /**
     * 
     */
    readonly predicted_has_memory_problems_reasoning?: string | null;
    /**
     * 
     */
    readonly predicted_has_memory_problems_visual_references?: Array<VisualReference>;
    /**
     * true=BIMS score 12 or lower, false=BIMS score greater than 12, null=Not documented
     */
    bims_score_12_or_lower?: boolean | null;
    /**
     * true=BIMS score 12 or lower, false=BIMS score greater than 12, null=Not documented
     */
    readonly predicted_bims_score_12_or_lower?: boolean | null;
    /**
     * 
     */
    readonly predicted_bims_score_12_or_lower_reasoning?: string | null;
    /**
     * 
     */
    readonly predicted_bims_score_12_or_lower_visual_references?: Array<VisualReference>;
}



/**
 * Check if a given object implements the CognitiveLevelAssessmentForm interface.
 */
export function instanceOfCognitiveLevelAssessmentForm(value: object): value is CognitiveLevelAssessmentForm {
    return true;
}

export function CognitiveLevelAssessmentFormFromJSON(json: any): CognitiveLevelAssessmentForm {
    return CognitiveLevelAssessmentFormFromJSONTyped(json, false);
}

export function CognitiveLevelAssessmentFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): CognitiveLevelAssessmentForm {
    if (json == null) {
        return json;
    }
    return {
        
        'severe_impairment': json['severe_impairment'] == null ? undefined : json['severe_impairment'],
        'predicted_severe_impairment': json['predicted_severe_impairment'] == null ? undefined : json['predicted_severe_impairment'],
        'predicted_severe_impairment_reasoning': json['predicted_severe_impairment_reasoning'] === undefined ? undefined : json['predicted_severe_impairment_reasoning'] === null ? null : json['predicted_severe_impairment_reasoning'],
        'predicted_severe_impairment_visual_references': json['predicted_severe_impairment_visual_references'] == null ? undefined : ((json['predicted_severe_impairment_visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
        'skills_for_daily_decision_making': json['skills_for_daily_decision_making'] == null ? undefined : DailyDecisionMakingSkillsOptionFromJSON(json['skills_for_daily_decision_making']),
        'predicted_skills_for_daily_decision_making': json['predicted_skills_for_daily_decision_making'] == null ? undefined : DailyDecisionMakingSkillsOptionFromJSON(json['predicted_skills_for_daily_decision_making']),
        'predicted_skills_for_daily_decision_making_reasoning': json['predicted_skills_for_daily_decision_making_reasoning'] === undefined ? undefined : json['predicted_skills_for_daily_decision_making_reasoning'] === null ? null : json['predicted_skills_for_daily_decision_making_reasoning'],
        'predicted_skills_for_daily_decision_making_visual_references': json['predicted_skills_for_daily_decision_making_visual_references'] == null ? undefined : ((json['predicted_skills_for_daily_decision_making_visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
        'makes_self_understood': json['makes_self_understood'] == null ? undefined : MakesSelfUnderstoodOptionFromJSON(json['makes_self_understood']),
        'predicted_makes_self_understood': json['predicted_makes_self_understood'] == null ? undefined : MakesSelfUnderstoodOptionFromJSON(json['predicted_makes_self_understood']),
        'predicted_makes_self_understood_reasoning': json['predicted_makes_self_understood_reasoning'] === undefined ? undefined : json['predicted_makes_self_understood_reasoning'] === null ? null : json['predicted_makes_self_understood_reasoning'],
        'predicted_makes_self_understood_visual_references': json['predicted_makes_self_understood_visual_references'] == null ? undefined : ((json['predicted_makes_self_understood_visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
        'has_memory_problems': json['has_memory_problems'] == null ? undefined : json['has_memory_problems'],
        'predicted_has_memory_problems': json['predicted_has_memory_problems'] == null ? undefined : json['predicted_has_memory_problems'],
        'predicted_has_memory_problems_reasoning': json['predicted_has_memory_problems_reasoning'] === undefined ? undefined : json['predicted_has_memory_problems_reasoning'] === null ? null : json['predicted_has_memory_problems_reasoning'],
        'predicted_has_memory_problems_visual_references': json['predicted_has_memory_problems_visual_references'] == null ? undefined : ((json['predicted_has_memory_problems_visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
        'bims_score_12_or_lower': json['bims_score_12_or_lower'] === undefined ? undefined : json['bims_score_12_or_lower'] === null ? null : json['bims_score_12_or_lower'],
        'predicted_bims_score_12_or_lower': json['predicted_bims_score_12_or_lower'] === undefined ? undefined : json['predicted_bims_score_12_or_lower'] === null ? null : json['predicted_bims_score_12_or_lower'],
        'predicted_bims_score_12_or_lower_reasoning': json['predicted_bims_score_12_or_lower_reasoning'] === undefined ? undefined : json['predicted_bims_score_12_or_lower_reasoning'] === null ? null : json['predicted_bims_score_12_or_lower_reasoning'],
        'predicted_bims_score_12_or_lower_visual_references': json['predicted_bims_score_12_or_lower_visual_references'] == null ? undefined : ((json['predicted_bims_score_12_or_lower_visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
    };
}

export function CognitiveLevelAssessmentFormToJSON(json: any): CognitiveLevelAssessmentForm {
    return CognitiveLevelAssessmentFormToJSONTyped(json, false);
}

export function CognitiveLevelAssessmentFormToJSONTyped(value?: Omit<CognitiveLevelAssessmentForm, 'predicted_severe_impairment'|'predicted_severe_impairment_reasoning'|'predicted_severe_impairment_visual_references'|'predicted_skills_for_daily_decision_making'|'predicted_skills_for_daily_decision_making_reasoning'|'predicted_skills_for_daily_decision_making_visual_references'|'predicted_makes_self_understood'|'predicted_makes_self_understood_reasoning'|'predicted_makes_self_understood_visual_references'|'predicted_has_memory_problems'|'predicted_has_memory_problems_reasoning'|'predicted_has_memory_problems_visual_references'|'predicted_bims_score_12_or_lower'|'predicted_bims_score_12_or_lower_reasoning'|'predicted_bims_score_12_or_lower_visual_references'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'severe_impairment': value['severe_impairment'],
        'skills_for_daily_decision_making': DailyDecisionMakingSkillsOptionToJSON(value['skills_for_daily_decision_making']),
        'makes_self_understood': MakesSelfUnderstoodOptionToJSON(value['makes_self_understood']),
        'has_memory_problems': value['has_memory_problems'],
        'bims_score_12_or_lower': value['bims_score_12_or_lower'],
    };
}

